$(document).ready(function(){
  $spr.iframeEntry();
  $spr.productTabs();
  $spr.categoryMore();
  if ($(window).width() <= 1199) {
    $spr.mobileNav();
  }
  $spr.mobileFooter();
  $spr.tableEntry();
  $spr.checkWindowScroll();
});
var $spr = {
  checkWindowScroll: function(){
    var $scrollTop = $(window).scrollTop();
    if ($('.site-main').length > 0) {
      if ($scrollTop >= $('.site-main').offset().top) {
        $('.site-header').addClass('site-header-rs--scrolled');
      } else {
        $('.site-header').removeClass('site-header-rs--scrolled');
      }
    }
  },
  mobileFooter: function(){
    $('.site-footer-block-title').on('click',function(e){
      e.preventDefault();
      $(this).closest('.site-footer-block-item').toggleClass('expanded');
    });
    $('.site-footer-block-item').eq(1).addClass('expanded');
  },
  mobileNav: function(){
    $('body').on('click','.site-header .gm-level-0 > .gm-target',function(e){
      e.preventDefault();
      e.stopPropagation();
      var $target = $(this).closest('.gm-level-0');
      if ($target.find('.gm-submenu').length === 0) {
        window.location.href = $(this).attr('href');
        return;
      }
      if (!$target.hasClass('gm-active')) {
        $('.site-header .gm-item').removeClass('gm-active');
        $('body').addClass('subactive');
        $target.addClass('gm-active');
        $subHtml = $target.children('.gm-submenu').html();
        $('#submenu-mobile').html($subHtml);
      } else {
        $('body').removeClass('subactive');
        $target.removeClass('gm-active');
        $('#submenu-mobile').html('');
      }
    });
    $('body').on('click','.submenu-overlay',function(e){
      $('body').removeClass('subactive');
      $('.site-header .gm-level-0').removeClass('gm-active');
      $('.#submenu-mobile').html('');
    });
  },
  testimonialHeight: function(){
    var t=0; // the height of the highest element (after the function runs)
    var t_elem;  // the highest element (after the function runs)
    $('.testimonial__text').each(function () {
        $this = $(this);
        if ( $this.outerHeight() > t ) {
            t_elem=this;
            t=$this.outerHeight();
        }
    });
    $('.testimonial__text').css('min-height',t);
  },
  subcategoryCheck: function(){
    if ($('.productgrid--masthead .collections-list').length > 0 && $('.productgrid--masthead .collections-list li').length > 8) {
      $('.productgrid--masthead .collections-list').addClass('has-more');
      $('body').on('click','.cat-more',function(e){
        var $self = $(this);
        $self.closest('.collections-list').toggleClass('expanded');
      });
    }
  },
  categoryMore: function(){
    $('body').on('click','.rs-collection--description .btn-more',function(e){
      e.preventDefault();
      var $self = $(this);
      var $target = $self.closest('.rs-collection--description');
      $target.toggleClass('show');
    });
  },
  productTabs: function(){
    var $link = $('.info-tab-link');
    $link.on('click',function(e){
      e.preventDefault();
      var $self = $(this);
      var $target = $('#tab--'+$self.data('tab'));
      $link.removeClass('active');
      $self.addClass('active');
      $self.closest('.tab-container').find('.tab-panel').removeClass('active');
      $target.addClass('active');
    });
    $('.tab--title').on('click',function(e){
      e.preventDefault();
      var $self = $(this);
      $self.closest('.tab-panel').toggleClass('active');
    });
  },
  iframeEntry: function(){
      if ($(".entry iframe").length > 0) {
        $(".entry iframe").each(function(){
          var $self = $(this);
          if ($self.closest(".vce-yt-video-player").length === 0 && $self.attr("src").indexOf('youtube') > -1 || $self.attr("src").indexOf('vimeo') > -1) {
              $(this).wrap('<div class="rs-video"><div class="video-container"></div></div>');
            }
        });
      }
  },
  tableEntry: function(){
      if ($(".entry table").length > 0) {
        $(".entry table").each(function(){
          var $self = $(this);
          if ($self.closest(".table-container").length === 0) {
              $(this).wrap('<div class="table-container"></div>');
            }
        });
      }
  }
}

$(window).on('load', function() {
  // Run code
  var url = $(location).attr('pathname');
  var htmlCat = '<ul>';
  var checksubcat = false;
  $('#AccessibleNav .gm-current-item .gm-links .gm-item').each(function() {
    checksubcat = true;
    var catName = $(this).find('.gm-text').html();
    var catUrl = $(this).find('.gm-target').attr('href');
    var catImg = $(this).find('.gm-icon-img').html();
    if(catUrl === 'undefined' || catUrl == null){
    }else{
      htmlCat += '<li>';
      htmlCat += '<a href="'+catUrl+'">';
      if(catImg === 'undefined' || catImg == null){
    }else{
        htmlCat += '<span class="cat-img">'+catImg+'</span>';
      }
      
      htmlCat += '<span class="cat-name">'+catName+'</span>';
      htmlCat += '</a></li>';
    }
  });
  if(checksubcat == false){
    $('#AccessibleNav .gm-current-item .gm-submenu .gm-grid .gm-item').each(function() {
    var catName = $(this).find('.gm-text').html();
    var catUrl = $(this).find('a').attr('href');
    var catImg = '<img src="'+$(this).find('img').attr('src')+'" />';
    if(catUrl === 'undefined' || catUrl == null){
    }else{
      htmlCat += '<li>';
      htmlCat += '<a href="'+catUrl+'">';
      if(catImg === 'undefined' || catImg == null){
    }else{
        htmlCat += '<span class="cat-img">'+catImg+'</span>';
      }
      
      htmlCat += '<span class="cat-name">'+catName+'</span>';
      htmlCat += '</a></li>';
    }
  });
  }
  

  
  htmlCat += '</ul><div class="cat-more"><span class="more">Show All Categories</span><span class="less">Show less categories</span></div>';
  if('.gm-level-0.gm-current-item>a.gm-current-item'){
    $('.collections-list').html(htmlCat);
  }
  
  
  $spr.subcategoryCheck();
  $spr.testimonialHeight();
  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  if($('.globo-swatch-product-detail').length > 0){
    var sizeSize = $('.ul-globo-dropdown-option .select-option--dropdown:first-child input').val();
    var labelColour = $('body .globo-swatch-product-detail input:checked').val();
    $('.swatch--gl .name-option[data-name="Size (mm)"] .name-variant').html(': '+sizeSize);
    $('.swatch--gl .name-option[data-name="Select Colour"] .name-variant').html(': '+labelColour);
  }
  
  
});
$(window).on('scroll', function(e) {
  $spr.checkWindowScroll();
});